module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-3-8127378b56d5a8b96dc0a57973450f7d.svg";